import React from "react";
import ItemsPage from "./ItemsTab";
import CategoriesPage from "./Categories";
import OrdersPage from "./OrdersTab";
import SoldoutPage from "./Soldout";
import Customers from "./CustomersTab";
import Analytics from "./Analytics";
import TableBookings from "./TableBookings";
import EasterBookings from "./EasterBookings"

const handleDragOver = (e) => {
  e.preventDefault();
  e.dataTransfer.dropEffect = "move";
};

const MainContent = ({ activeTab, setIsAnyModalActive, isAnyModalActive }) => {
  return (
    <div className="main-content" onDragOver={(e) => handleDragOver(e)}>
      {activeTab === "categories" && (
        <CategoriesPage setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "items" && (
        <ItemsPage setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "outofstock" && (
        <SoldoutPage setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "orders" && (
        <OrdersPage
          setIsAnyModalActive={setIsAnyModalActive}
          isAnyModalActive={isAnyModalActive}
        />
      )}
      {activeTab === "table-bookings" && (
        <TableBookings setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "easter-bookings" && (
        <EasterBookings setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "customers" && (
        <Customers setIsAnyModalActive={setIsAnyModalActive} />
      )}
      {activeTab === "analytics" && (
        <Analytics setIsAnyModalActive={setIsAnyModalActive} />
      )}
    </div>
  );
};

export default MainContent;
